var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.35a.65.65 0 0 1 .65.65v12.43l5.89-5.89a.65.65 0 1 1 .92.92l-7 7a.65.65 0 0 1-.92 0l-7-7a.65.65 0 1 1 .92-.92l5.89 5.89V5a.65.65 0 0 1 .65-.65Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA0LjM1QzEyLjM1OSA0LjM1IDEyLjY1IDQuNjQxMDEgMTIuNjUgNUwxMi42NSAxNy40MzA4TDE4LjU0MDQgMTEuNTQwNEMxOC43OTQyIDExLjI4NjUgMTkuMjA1OCAxMS4yODY1IDE5LjQ1OTYgMTEuNTQwNEMxOS43MTM1IDExLjc5NDIgMTkuNzEzNSAxMi4yMDU4IDE5LjQ1OTYgMTIuNDU5NkwxMi40NTk2IDE5LjQ1OTZDMTIuMjA1OCAxOS43MTM1IDExLjc5NDIgMTkuNzEzNSAxMS41NDA0IDE5LjQ1OTZMNC41NDAzOCAxMi40NTk2QzQuMjg2NTQgMTIuMjA1OCA0LjI4NjU0IDExLjc5NDIgNC41NDAzOCAxMS41NDA0QzQuNzk0MjIgMTEuMjg2NSA1LjIwNTc4IDExLjI4NjUgNS40NTk2MiAxMS41NDA0TDExLjM1IDE3LjQzMDhMMTEuMzUgNUMxMS4zNSA0LjY0MTAxIDExLjY0MSA0LjM1IDEyIDQuMzVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";